import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component, OnInit, ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { Observable } from 'rxjs';

import { BaseSegmentComponent } from '../base/_base-segment.component';
import { PRICE_SHEETS_NAME } from '../../variables';
import { PriceSheetsFormComponent } from './price-sheets-form/price-sheets-form.component';
import { BrandInformationService } from '../../brand-information.service';
import { InformationPageService } from '../../../information-page/information-page.service';
import { PriceSheetService } from 'shared/price-sheet/price-sheet.service';
import { BrandService } from 'shared/brand/brand.service';
import { PermissionsService } from 'shared/permissions/permissions.service';
import {ProductPanelComponent} from '../../../../product-panel/product-panel.component';
import {BRAND_NAME} from '../../../account-information/variables';


@Component({
  moduleId: module.id,
  selector: 'price-sheets-segment',
  templateUrl: 'price-sheets.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceSheetsComponent extends BaseSegmentComponent implements OnInit {
  name: string = PRICE_SHEETS_NAME;

  @ViewChild(PriceSheetsFormComponent, {static: true})
  // @ts-ignore
  protected formComponent: PriceSheetsFormComponent;

  constructor(
    public priceSheetService: PriceSheetService,
    protected router: Router,
    protected brandInformationService: BrandInformationService,
    protected informationPageService: InformationPageService,
    protected permissionsService: PermissionsService,
    protected ref: ChangeDetectorRef,
    private brandService: BrandService,
  ) {
    super(
      router,
      brandInformationService,
      informationPageService,
      permissionsService,
      ref,
    );
  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngOnInit() {
    super.ngOnInit();
    this.refresh();
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  setData(data: any) {
    const compatData = data.map(i => {
      return {
        ...i,
        currency_code: !_.isArray(i.currency_code) ? [i.currency_code] : i.currency_code,
      };
    });
    super.setData(compatData);
  }

  fetchFormData(): Observable<any> {
    return this.priceSheetService.fetchAll(this.brandService.getBrand());
  }

  putFormData(): Observable<any> {
    const data = this.prepareSavingData(this.formComponent.form.getRawValue().priceSheets);
    return this.priceSheetService.putData(this.brandService.getBrand(), data);
  }

  getError() {
    return this.formComponent && this.formComponent.getError();
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/

   private prepareSavingData(data: any): any {
    if (!data) { return []; }
    _.each(data, (item: any) => {
      if (!item.secondary && !item.primary) {
        item.default = null;
        return;
      }
      if (item.primary) { item.default = 1; }
      if (item.secondary) { item.default = 2; }
    });
    return _.map(data, (item: any) => _.omit(item, 'isNewRow', 'primary', 'secondary'));
  }

  cancelClickHandler() {
    this.informationPageService.emitCancel(BRAND_NAME);
  }

  saveChangesClickHandler() {
    this.informationPageService.emitShowBeforeSaveModal();
  }

  onSaved(event: any) {
    this.priceSheetService.emitIsSaved();
  }

  protected showLoader() {
    this.formComponent.loader.show();
  }

  protected hideLoader() {
    this.formComponent.loader.hide();
  }
}
